import React from "react";
import "./LetsPlan.css";

const LetsPlan = () => {
  return (
    <div className="lets-plan">
      <h1>Let's start planning your perfect special occasion together!</h1>
      <hr />
      <p>
        Get a full-scale analysis of your business and recommended solutions to
        increase your profits.
      </p>
      <button>REQUEST A QUOTE</button>
    </div>
  );
};

export default LetsPlan;
